import { Injectable } from '@angular/core';

@Injectable()
export class GeneralService {

  constructor() { }

  // BASE_URL = 'http://veepal.co.in/veepal-live';
  // REDIRECT_URL = 'http://veepal.co.in/veepal-live/';

  // SEND_EMAIL_API = 'http://veepal.co.in/veepal-live/assets/php/sendemail-angular.php';

  BASE_URL = 'https://www.veepal.com';
  REDIRECT_URL = 'https://www.veepal.com/';

  SEND_EMAIL_API = 'https://www.veepal.com/assets/php/sendemail-angular.php';

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/services/general.service.ts